export default "__VITE_ASSET__PMUYapUm__"